import { ApiHandler } from './api-handler';
import { SessionApiService } from './session';
import { OnRefreshFail } from './types';
import { UserApiService } from './user';
import { DoctorApiService } from './doctors';
import { ReferenceApiService } from './reference';
import { PlatformApiService } from './platform';
import { BillingApi } from './billing';
import { OnboardingApiService } from './onboarding';

export const ApiService = {
  User: UserApiService,
  Doctor: DoctorApiService,
  Reference: ReferenceApiService,
  Session: SessionApiService,
  Platform: PlatformApiService,
  Billing: BillingApi,
  Onboarding: OnboardingApiService,

  setOnRefreshFailHandler(handler: OnRefreshFail) {
    ApiHandler.onRefreshFailHandler = handler;
  },
} as const;
